import AboveMiddleBelow from "../../components/LKG/Mathematics/AboveMiddleBelow";
import BeforeAfter from "../../components/LKG/Mathematics/BeforeAfter";
import BigSmall from "../../components/LKG/Mathematics/BigSmall";
import FullEmpty from "../../components/LKG/Mathematics/FullEmpty";
import HeavyLight from "../../components/LKG/Mathematics/HeavyLight";
import LeftRight from "../../components/LKG/Mathematics/LeftRight";
import LongShort from "../../components/LKG/Mathematics/LongShort";
import MoreLess from "../../components/LKG/Mathematics/MoreLess";
import NearFar from "../../components/LKG/Mathematics/NearFar";
import OddOneOut from "../../components/LKG/Mathematics/OddOneOut";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}

document.title = "Mamas Guidance - LKG - Mathematics";

const topics: MenuItem[] = [
    { url: "/lkg/mathematics/pre-math-concepts/big-small", title: "Big - Small", component: BigSmall},
    { url: "/lkg/mathematics/pre-math-concepts/long-short", title: "Long - Short", component: LongShort},
    { url: "/lkg/mathematics/pre-math-concepts/heavy-light", title: "Heavy - Light", component: HeavyLight},
    { url: "/lkg/mathematics/pre-math-concepts/full-empty", title: "Full - Empty", component: FullEmpty},
    { url: "/lkg/mathematics/pre-math-concepts/more-less", title: "More - Less", component: MoreLess},
    { url: "/lkg/mathematics/pre-math-concepts/near-far", title: "Near - Far", component: NearFar},
    { url: "/lkg/mathematics/pre-math-concepts/above-middle-below", title: "Above - Middle - Below", component: AboveMiddleBelow},
    { url: "/lkg/mathematics/pre-math-concepts/left-right", title: "Left - Right", component: LeftRight},
    { url: "/lkg/mathematics/pre-math-concepts/before-after-between", title: "Before - Between - After", component: BeforeAfter},
    { url: "/lkg/mathematics/pre-math-concepts/odd-one-out", title: "Odd One Out", component: OddOneOut},
];


export default topics;